<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1000px'"
    :appendToBody="true"
    :modalAppendToBody="true"
    :offsetTop="'10vh'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="padding-bottom-10">
        <h3 class="dialogTitle">{{ dialogTitle }}</h3>

        <div class="select-Unit-BanHanh">
          <!-- department-tree -->
          <div class="content">
            <el-row :gutter="18">
              <el-col :span="12" class="fix__top">
                <el-input
                  class="style-fullWidth searchBox"
                  v-model="search"
                  size="medium"
                  placeholder="Nhập tên đơn vị để tìm kiếm"
                  prefix-icon="el-icon-search"
                  @keydown.enter.exact.native="searchTree"
                ></el-input>
              </el-col>
            </el-row>

            <VuePerfectScrollbar
              class="scroll-scope listCompanies"
              :settings="settings"
            >
              <el-tree
                class="filter-tree"
                :data="departmentTree"
                default-expand-all
                ref="departmentTree"
                :filter-node-method="filterDepartmentTreeNode"
              >
                <span
                  class="custom-tree-node tree_unit between"
                  slot-scope="{ node, data }"
                >
                  <span v-if="data.nodeType == DEPARTMENT_TREE.NODE_TYPE.DEPT">
                    <el-checkbox
                      @click.native.stop="() => true"
                      @change="nodeCheckedChange(data)"
                      v-model="data.checked"
                    ></el-checkbox>
                    <span
                      >&nbsp;{{
                        data.department ? data.department.deptName : null
                      }}</span
                    >
                  </span>

                  <span
                    v-else-if="
                      [
                        DEPARTMENT_TREE.NODE_TYPE.DVTT,
                        DEPARTMENT_TREE.NODE_TYPE.PBCN,
                      ].indexOf(data.nodeType) != -1
                    "
                  >
                    <span
                      >&nbsp;{{
                        data.nodeType == DEPARTMENT_TREE.NODE_TYPE.DVTT
                          ? "Các chi nhánh"
                          : "Phòng, Ban, Trung tâm"
                      }}</span
                    >
                  </span>
                </span>
              </el-tree>
            </VuePerfectScrollbar>
          </div>
          <!-- department-tree:end -->
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__left form-button__action">
        <el-button class="dialogBtnPrimary btn-none__border" @click="banHanh">
          Chọn&nbsp;<i class="fas fa-arrow-circle-right font-size__small"></i>
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import constants from "../../../constants";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import displayDepartmentTreeMixin from "../../../mixins/displayDepartmentTreeMixin";
import h from "../../../services/h";
import departmentService from "../../../services/departmentService";

export default {
  name: "selectDepartmentDialog",
  mixins: [displayDepartmentTreeMixin],
  props: [
    "isOpen",
    "multipleSelect",
    "title",
    "publisherId",
    "receiveDepartmentIds",
  ],
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    VuePerfectScrollbar,
  },

  data() {
    return {
      settings: { maxScrollbarLength: 750 },
      search: null,
      checkedNodes: [],
      lastCheckedNode: null,
      publisherDepartment: null,
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
    };
  },

  created() {
    // this.loadDepartments();
    this.loadPublisher();
  },
  computed: {
    dialogTitle() {
      return this.title ? this.title : "Nơi nhận bên trong";
    },
    rootDeptId() {
      return this.publisherDepartment
        ? this.publisherDepartment.parentId !== "ROOT"
          ? this.publisherDepartment.parentId || this.publisherDepartment.id
          : this.publisherDepartment.id
        : null;
    },
  },
  methods: {
    filterDepartmentTreeNode(value, data) {
      return (
        (!value
          ? true
          : (data.department.deptName || "")
              .toUpperCase()
              .indexOf(value.toUpperCase()) !== -1) && !this.checkPBCN(data)
      );
    },
    checkPBCN(node) {
      if (
        // this.publisherDepartment.deptType ===
        //   constants.DEPARTMENT.DEPT_TYPE.DVTT &&
        node.nodeType === this.DEPARTMENT_TREE.NODE_TYPE.PBCN
      )
        return true;
      let department = node.department;
      return (
        // this.publisherDepartment.deptType ===
        //   constants.DEPARTMENT.DEPT_TYPE.DVTT &&
        department.deptType === constants.DEPARTMENT.DEPT_TYPE.PBCN &&
        department.deptCode !== constants.DEPARTMENT.DEPT_CODE.TCT
      );
    },
    /**
     * chỉ hiện thị dept cha trực tiếp + dept anh/chị + dept con trực tiếp;
     * @returns {Promise<T | never>}
     */
    loadDepartments() {
      return departmentService
        .findAll({ sort: "path,asc" })
        .then((response) => {
          let departments = h.findAll(
            response.data,
            (item) =>
              item.status == constants.DEPARTMENT.STATUS.ACTIVE ||
              (this.receiveDepartmentIds &&
                item.id == this.receiveDepartmentIds)
          );

          let publisher = response.data.filter(
            (item) => item.id == this.publisherId
          );

          this.departments = h.findAll(
            departments,
            (department) =>
              department.id == this.rootDeptId ||
              department.parentId == this.rootDeptId ||
              (this.publisherId && department.parentId == this.publisherId) ||
              !department.parentId ||
              department.parentId == publisher.parentId
          );
          this.buildDepartmentTree();
          this.$nextTick(() => this.searchTree());
        });
    },
    buildDepartmentTree() {
      h.each(this.departments, (item) => {
        if (item.id === this.rootDeptId) {
          let data = this.buildDataForNode(item);
          this.departmentTree.push(this.buildDepartmentTreeForNode(data));
        }
      });
    },

    buildDataForNode(department) {
      // let checked = this.receiveDepartmentIds.indexOf(department.id) !== -1;
      let checked =
        this.receiveDepartmentIds && this.receiveDepartmentIds == department.id;
      return {
        department: department,
        checked: checked,
        nodeType: this.DEPARTMENT_TREE.NODE_TYPE.DEPT,
      };
    },

    buildDepartmentTreeForNode(node) {
      if (node.checked) {
        this.checkedNodes.push(node);
      }

      if (node && node.nodeType == this.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
        let department = node.department;
        /**
         * nếu là node TCT thì build thành 2 node trung gian phòng-ban-chức-năng & đơn-vị-trực thuộc
         */
        if (department.deptCode == constants.DEPARTMENT.DEPT_CODE.TCT) {
          node.children = [
            this.buildDepartmentTreeForNode({
              nodeType: this.DEPARTMENT_TREE.NODE_TYPE.PBCN,
              department: department,
            }),
            this.buildDepartmentTreeForNode({
              nodeType: this.DEPARTMENT_TREE.NODE_TYPE.DVTT,
              department: department,
            }),
          ];
        } else {
          let departmentId = department.id;
          let childrenDepartments = h.findAll(
            this.departments,
            (item) => item.parentId == departmentId
          );
          node.children = h.collect(childrenDepartments, (item) =>
            this.buildDepartmentTreeForNode(this.buildDataForNode(item))
          );
        }
      } else {
        let department = node.department;
        let childrenDepartments = h.findAll(
          this.departments,
          (item) =>
            item.parentId == department.id &&
            item.deptType == this.getDeptTypeByNodeType(node.nodeType)
        );
        node.children = h.collect(childrenDepartments, (item) =>
          this.buildDepartmentTreeForNode(this.buildDataForNode(item))
        );
      }

      return node;
    },

    loadPublisher() {
      departmentService.findById(this.publisherId).then((response) => {
        this.publisherDepartment = response.data;

        this.loadDepartments();
      });
    },
    banHanh() {
      let event;
      if (this.multipleSelect) {
        event = {
          selectedDepartments: h.collect(
            this.checkedNodes,
            (node) => node.department
          ),
        };
      } else {
        event = {
          selectedDepartment:
            this.lastCheckedNode && this.lastCheckedNode.checked
              ? this.lastCheckedNode.department
              : null,
        };
      }

      this.$emit("change", event);
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    nodeCheckedChange(data) {
      !this.multipleSelect &&
        this.lastCheckedNode &&
        this.lastCheckedNode != data &&
        (this.lastCheckedNode.checked = false);
      this.lastCheckedNode = data;
      data.checked
        ? this.checkedNodes.push(data)
        : this.checkedNodes.splice(this.checkedNodes.indexOf(data), 1);
    },
  },
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 200px;
  position: relative;
  /* margin-bottom: 10px; */
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}

.searchBox {
  /* background-color: var(--color-light-2); */
  /* border-color:transparent; */
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/selectDepartmentDialog.vue